import React from "react";

export default function ProtectedRoute({ children, isAuthenticated, onLogout }) {
  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="app-container-with-logout">
      <div className="logout-bar">
        <span className="user-info">
          {JSON.parse(localStorage.getItem("user"))?.email || "User"}
        </span>
        <button onClick={onLogout} className="btn-logout">
          Logout
        </button>
      </div>
      {children}
    </div>
  );
}
